import { render } from "./DomainSearch.vue?vue&type=template&id=4dd267f8"
import script from "./DomainSearch.vue?vue&type=script&lang=js"
export * from "./DomainSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__